import {
  Component,
  ChangeDetectionStrategy,
  DoCheck,
  Input,
  ChangeDetectorRef
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-reactive-textarea-input',
  templateUrl: './reactive-textarea-input.component.html',
  styleUrls: ['./reactive-textarea-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReactiveTextareaInputComponent implements DoCheck {
  /**
   * 'fieldId' is a unique field identification
   * Example: 'email', 'password'
   *    ---REQUIRED PROPERTY---
   */
  @Input() isInline = false;
  @Input() showError = true;
  @Input() fieldId: string;
  @Input() filedLabel: string;
  @Input() placeHolder: string;
  @Input() showTooltip = false;
  @Input() descriptionTooltip: string;
  @Input() topTooltipHover: number;
  @Input() leftTooltipHover: number;

  /**
   * 'control' is a reactive form validator/value controller
   *    ---REQUIRED PROPERTY---
   */
  @Input() control: AbstractControl;

  private _validationErrors = new BehaviorSubject<object>(null);
  public validationErrors$ = this._validationErrors.asObservable();

  ngDoCheck() {
    if (
      this.control &&
      this.control.touched &&
      this.control.invalid &&
      this.showError
    ) {
      this._validationErrors.next(this.control['errors']);
    } else {
      this._validationErrors.next(null);
    }
  }
}
